import cn from "classnames";
import Styles from "../Icon.module.scss";
import { IconProps, IconSizes } from "../icon-prop-types";

export const AddIcon = ({ fill = "black", size = "xsmall" }: IconProps) => {
  const fillStyles = cn(Styles[fill], Styles.fill);
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="-7 2 14 14"
    >
      <path
        transform="rotate(45)"
        className={fillStyles}
        d="M7.909 7l2.403-2.402a.643.643 0 0 0-.91-.91L7 6.091 4.597 3.688a.643.643 0 0 0-.91.91L6.09 7 3.687 9.402a.645.645 0 0 0 .455 1.098.644.644 0 0 0 .455-.188L7 7.909l2.402 2.403a.644.644 0 0 0 .91-.91L7.91 7z"
      />
    </svg>
  );
};

export default AddIcon;
